module.exports = __webpack_public_path__ + "static/assets/f9cf0e4bdc6e4b45a0bdcd53a616fde6.svg";